export const PAY_TYPE = {}
PAY_TYPE[PAY_TYPE["PAY_PAL"] = "1"] = "paypal支付";
PAY_TYPE[PAY_TYPE["ON_DOWN"] = "2"] = "线下支付";


/** 学段 */
export const XUEDUAN = {
    XIAOXUE: '1',
    CHUZHONG: '2',
    GAOZHONG: '3',
    YINIANJI: '1',
    CHUYI: '7',
    GAOYI: '10',
    // 默认年级
    DEFAULT: 1,
    getArr() {
        return [{
                name: '小学',
                value: this.XIAOXUE,
                children: [{
                        name: '一年级',
                        value: this.YINIANJI
                    },
                    {
                        name: '二年级',
                        value: '2'
                    },
                    {
                        name: '三年级',
                        value: '3'
                    },
                    {
                        name: '四年级',
                        value: '4'
                    },
                    {
                        name: '五年级',
                        value: '5'
                    },
                    {
                        name: '六年级',
                        value: '6'
                    },
                ]
            },
            {
                name: '初中',
                value: this.CHUZHONG,
                children: [{
                        name: '初一',
                        value: this.CHUYI
                    },
                    {
                        name: '初二',
                        value: '8'
                    },
                    {
                        name: '初三',
                        value: '9'
                    },
                ]
            },
            {
                name: '高中',
                value: this.GAOZHONG,
                children: [{
                        name: '高一',
                        value: this.GAOYI
                    },
                    {
                        name: '高二',
                        value: '11'
                    },
                    {
                        name: '高三',
                        value: '12'
                    },
                ]
            },
        ]
    }
}

/** 资源类型 */
export const COURSE_DATA = {
    DEFAULT: "",
    getArr() {
        return [{
                name: '全部',
                value: '',
            },
            {
                name: '教案',
                value: '2',
            },
            {
                name: '课件',
                value: '3',
            },
            {
                name: '学案',
                value: '4',
            },
            {
                name: '视频',
                value: '5',
            },
            {
                name: '图片',
                value: '6',
            },
            {
                name: '素材',
                value: '7',
            },
        ]
    },
    getNameById(id = "") {
        if (id == '2') return '教案';
        if (id == '3') return '课件';
        if (id == '4') return '学案';
        if (id == '5') return '视频';
        if (id == '6') return '图片';
        return '素材';
    }
}

/** 试题类型 */
export const TEST_PAPER_TYPE = {
    /** 默认值 */
    DEFAULT: '1',
    getArr() {
        return [{
                name: '全部',
                value: '',
            },
            {
                name: '月考/阶段',
                value: '2',
            },
            {
                name: '期中/期末',
                value: '3',
            },
            {
                name: '学业/小高考/会考',
                value: '4',
            },
        ]
    },
}

/** 模块类型 */
export const MODE_TYPE = {
    /** 资源 */
    SOURCE: "1",
    /** 试题 */
    TEST_PAPER: '2',
    /** 班会 */
    BANHUI: '3'
}

/** 班会育人 */
export const BANHUI_TYPE = {
    DEFAULT: "0",
    TOW_DEFAULT: "0",
    getArr() {
        return [{
                name: '全部',
                value: '0',
                children: [{
                        name: '全部',
                        value: '0'
                    },
                    {
                        name: '安全类',
                        value: '1'
                    },
                    {
                        name: '教育类',
                        value: '2'
                    },
                    {
                        name: '文化类',
                        value: '3'
                    },
                ]
            },
            {
                name: '班会',
                value: '1',
                children: [{
                        name: '全部',
                        value: '0'
                    },
                    {
                        name: '安全类',
                        value: '1'
                    },
                    {
                        name: '教育类',
                        value: '2'
                    },
                    {
                        name: '文化类',
                        value: '3'
                    },
                ]
            },
            {
                name: '家长会',
                value: '2',
                children: []
            },
            {
                name: '班主任管理',
                value: '3',
                children: []
            },
        ]
    }
}

// 邮箱正则
export const EMAIL_REG = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
